/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_Group_HoldingInputs */

const en_us2_progress_report_group_holding = /** @type {(inputs: Progress_Report_Group_HoldingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Holding`)
};

const pt_br2_progress_report_group_holding = /** @type {(inputs: Progress_Report_Group_HoldingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estáveis`)
};

const es_419_progress_report_group_holding = /** @type {(inputs: Progress_Report_Group_HoldingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estables`)
};

const pt_pt2_progress_report_group_holding = /** @type {(inputs: Progress_Report_Group_HoldingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estáveis`)
};

const fr_fr2_progress_report_group_holding = /** @type {(inputs: Progress_Report_Group_HoldingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stables`)
};

const de_de2_progress_report_group_holding = /** @type {(inputs: Progress_Report_Group_HoldingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stabil`)
};

const it_it2_progress_report_group_holding = /** @type {(inputs: Progress_Report_Group_HoldingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stabili`)
};

/**
* | output |
* | --- |
* | "Holding" |
*
* @param {Progress_Report_Group_HoldingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_group_holding = /** @type {((inputs?: Progress_Report_Group_HoldingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Group_HoldingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_group_holding(inputs)
	if (locale === "es-419") return es_419_progress_report_group_holding(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_group_holding(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_group_holding(inputs)
	if (locale === "de-DE") return de_de2_progress_report_group_holding(inputs)
	if (locale === "it-IT") return it_it2_progress_report_group_holding(inputs)
	return en_us2_progress_report_group_holding(inputs)
});
export { progress_report_group_holding as "progress-report.group_holding" }